/**
 * Checks if the input text represents a phone number.
 *
 * @param {string} searchText - the input search text
 * @return {boolean} true if the input text represents a phone number, false otherwise
 */
const getIsPhoneNumber = (searchText: string) => /^(\d *|-|())+$/.test(searchText);

export default getIsPhoneNumber;
